module.exports = __webpack_public_path__ + "static/media/background-circle.fe85b7fb.svg";